import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { Azimuth } from 'entities/Azimuth';

export const azimuthApi = createApi({
  reducerPath: 'azimuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    prepareHeaders: (headers) => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          headers.set('Authorization', `Bearer ${JSON.parse(token)}`);
        }
      } catch (error) {
        console.warn('Error');
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAzimuthList: builder.query<{ success: boolean; data: Azimuth[] }, void>({
      query: () => {
        return {
          url: '/azimuths',
          credentials: 'include',
          mode: 'cors',
        };
      },
    }),
  }),
});

export const { useGetAzimuthListQuery } = azimuthApi;
